import React, { useEffect } from 'react';

export const HelmetProvider = ({ children }) => {
  return children;
};

export const Helmet = ({ children }) => {
  useEffect(() => {
    if (!children) return;
    const childArray = Array.isArray(children) ? children : [children];
    const titleEl = childArray.find(
      (el) => el && el.type === 'title' && typeof el.props?.children === 'string'
    );
    if (titleEl) {
      const prevTitle = document.title;
      document.title = titleEl.props.children;
      return () => {
        document.title = prevTitle;
      };
    }
  }, [children]);

  return null;
};
